module.exports = __webpack_public_path__ + "static/pme-d1bdc14bb89b0007e7fd9dd789871a95.svg";